module.exports = __webpack_public_path__ + "static/media/px.1dd7187a.hdr";